export default __webpack_public_path__ + "static/media/EnergySavingIcon.62b32f8a.svg";